const GraphIcon = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='32'
    height='32'
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    stroke-width='2'
    stroke-linecap='round'
    stroke-linejoin='round'
    className='lucide lucide-chart-column h-6 w-6 text-pink-500'
  >
    <path d='M3 3v16a2 2 0 0 0 2 2h16'></path>
    <path d='M18 17V9'></path>
    <path d='M13 17V5'></path>
    <path d='M8 17v-3'></path>
  </svg>
);

export default GraphIcon;
